import React, { useState, useEffect } from 'react';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { AppBar, Toolbar, Badge, Hidden, IconButton, Button } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import {BookmarkBorder, Dashboard, EmojiObjects} from '@material-ui/icons';
import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import InputIcon from '@material-ui/icons/Input';
import Cookies from 'universal-cookie';
import { AzureAD, AuthenticationState } from 'react-aad-msal';

import { AutoRotatingCarousel } from 'material-auto-rotating-carousel';
import { Slide } from 'material-auto-rotating-carousel';
import { red, blue, green } from '@material-ui/core/colors';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

import { authProvider } from 'views/SignIn/azure-connect/authProvider';

import { SignOutAPIReq, getFavoritesAPIReq, getTipsAPICall, getNumberOfNumberOffers } from 'utils/requests';

const cookies = new Cookies();



function Alert(props) {
  return <MuiAlert
    elevation={6}
    variant="filled"
    {...props}
         />;
}

// const removeCookies = () => {
//   let all = cookies.getAll()
//   for (let i = 0; i < all.length; i++) {
//     console.log(all[i])
//     cookies.remove(all[i], { path: '/' });
//   }
// }

const SignOut = (history, logout) => {
  // console.log("clicked")
  return SignOutAPIReq()
    .then((res)=>{
      // console.log(res)
      if(res === 102) {
        cookies.remove('hashedID');
        cookies.remove('firstName');
        cookies.remove('lastName');
        cookies.remove('school');
        cookies.remove('isAlumni');
        cookies.remove('isAdmin');
        cookies.remove('profilePicture');
        cookies.remove('auth');
        logout();
      }
      else
        alert('an error has occured')
    })
}

const logoutNormal = (history) => {
  return SignOutAPIReq()
    .then((res)=>{
      // console.log(res)
      if(res === 102) {
        cookies.remove('hashedID');
        cookies.remove('firstName');
        cookies.remove('lastName');
        cookies.remove('school');
        cookies.remove('isAlumni');
        cookies.remove('isAdmin');
        cookies.remove('profilePicture');
        cookies.remove('auth');
        history.push('/sign-in');
      }
      else
        alert('an error has occured')
    })
};


const useStyles = makeStyles(theme => ({
  root: {
    boxShadow: 'none'
  },
  flexGrow: {
    flexGrow: 1
  },
  signOutButton: {
    marginLeft: theme.spacing(1)
  },
  button: {
    backgroundColor: '#f5b335',
    color: '#ffffff'
  }
}));

const Topbar = props => {
  const { className, history, onSidebarOpen, ...rest } = props;

  const classes = useStyles();

  const [notifications, setNotifications] = useState(0);
  const [newOffersNotifications, setNewOffersNotifications] = useState(0);
  const [openTips, setOpenTips] = useState(false);
  const [openSnackBar, setOpenSnackBar] = React.useState(false);
  const [tips, setTips] = useState([]);
  // let tips = [];

  useEffect(() => {

    if (tips.length !== 0)
      setOpenTips(true);
  }, [tips]);

  const getTips = () =>{
    return getTipsAPICall()
      .then((res) => {
        if(res) {
          if(res.data.length!==0)
            setTips(res.data);
          else{
            // tips=data;
            setOpenSnackBar(true);
          }

          return res.data

        }
      //     // return res.data;
      //     // setTips(res.data)
      //     console.log(res.data)
      //     a = [...a, res.data]
      //     // setTips({tips:[...tips.tips, res.data[0]]})
      //     // res.data.map(tip=>{
      //     //   setTips({tips:[...tips, tip]})
      //     //
      //     //   console.log("tip", tips)
      //     // })
      //     // tips = res.data
      //     //   console.log(res.data[i])
      //
      //     console.log('tips: ',a)
      //   } else{
      //     alert('An arror happened while fetching for data');
      //   }
      // })
      // .then(()=>{
      //   if(a.length === 0)
      //     setOpenSnackBar(true);
      //   else
      //     setOpenTips(true);
      // }
      })

  }



  const getFavorites = () => {
    return getFavoritesAPIReq()
      .then((res) => {
        if (res && res.status === 'success'){
          setNotifications(res.data.length)
        } else {
          setNotifications(0)
        }
      })
  }

  const getNewOffersNotifications = () => {
    return getNumberOfNumberOffers()
      .then((res) => {
        if (res && res.status === 'success'){
          setNewOffersNotifications(res.data)
        } else {
          setNewOffersNotifications(0)
        }
      })
  }

  getFavorites()

  if(cookies.get("isAdmin"))
    getNewOffersNotifications()



  return (
    <AppBar
      {...rest}
      className={clsx(classes.root, className)}
      style={{ background: 'primary'}}
    >
      <Toolbar>
        <RouterLink to="/">
          <img
            alt="Logo"
            height="45px"
            src="https://cdn-pcs.auicareerspark.com/landing-assets/CareerSpark_nobgWH.png"
          />
        </RouterLink>
        <div className={classes.flexGrow} />
        <Hidden mdDown>
          {/* <IconButton color="inherit" onClick={() => history.push('/admin')}>
            <Badge
              badgeContent={notifications.length}
              color="primary"
              variant="dot"
            >
              <Dashboard />
            </Badge>
          </IconButton> */}
          <Button
            className={classes.button}
            onClick={() => {
              getTips()
            }}
            startIcon={<EmojiObjects />
            }
            variant="contained"
          >
              Career Tips
          </Button>
          <IconButton color="inherit">
            <Badge
              badgeContent={0}
              color="primary"
              variant="dot"
            >
              <NotificationsIcon />
            </Badge>
          </IconButton>
          <IconButton
            color="inherit"
            href="/favorites"
          >
            <Badge
              badgeContent={notifications}
              color="error"
            >
              <BookmarkBorder />
            </Badge>
          </IconButton>
          {
            (cookies.get("isAdmin") === "true")?

              <div>
                <IconButton
                  color="inherit"
                  href="/admin"
                >
                  <EqualizerIcon />
                </IconButton>

                <IconButton
                  color="inherit"
                  href="/unvalidated-offers"
                >
                  <Badge
                    badgeContent={newOffersNotifications}
                    color="error"
                  >
                    <LibraryBooksIcon />
                  </Badge>
                </IconButton>
              </div>
              :<div></div>
          }
          <AzureAD
            forceLogin={false}
            provider={authProvider}
          >
            {
              ({login, logout, authenticationState, error, accountInfo}) => {
                switch (authenticationState) {
                  case AuthenticationState.Unauthenticated:
                    return (
                      <IconButton
                        className={classes.signOutButton}
                        color="inherit"
                        onClick={() => {
                          logoutNormal(history)
                        }}
                      >
                        <InputIcon />
                      </IconButton>
                    )
                  case AuthenticationState.Authenticated:
                    return (
                      <IconButton
                        className={classes.signOutButton}
                        color="inherit"
                        onClick={() => {
                          SignOut(history, logout)
                        }}
                      >
                        <InputIcon />
                    
                      </IconButton>
                    )
                }
              }
            }
          </AzureAD>
        </Hidden>
        <Hidden lgUp>
          <IconButton
            color="inherit"
            onClick={onSidebarOpen}
          >
            <MenuIcon />
          </IconButton>
        </Hidden>
      </Toolbar>


      {tips ?<AutoRotatingCarousel
        landscape
        onClose={() => {
          setOpenTips( false );
        }}
        onStart={() => {
          setOpenTips( false );
        }}
        open={openTips}
        style={{ position: 'absolute' }}
      >
        {
          tips.map((tip) => {
            return (
              <Slide
                key={tip._id}
                media={<img src={tip.picture}/>}
                mediaBackgroundStyle={{backgroundColor: tip.isTargeted ? red[400] : blue[400]}}
                style={{backgroundColor: tip.isTargeted ? red[600] : blue[600]}}
                subtitle={tip.description}
                title={tip.title}
              />
            );
          })
        }

      </AutoRotatingCarousel>
        :<div />}


      <Snackbar
        autoHideDuration={6000}
        onClose={()=>{setOpenSnackBar(false)}}
        open={openSnackBar}
      >
        <Alert
          onClose={()=>{setOpenSnackBar(false)}}
          severity="error"
        >
          There is no tip for the moment
        </Alert>
      </Snackbar>
    </AppBar>
  );
};

Topbar.propTypes = {
  className: PropTypes.string,
  onSidebarOpen: PropTypes.func
};

export default withRouter(Topbar)
